import { useCandidateAuthStore, useCandidateLogout } from "@repo/auth";
import { Loader, Navbar } from "@repo/ui";
import { useQuery } from "convex/react";
import { useState } from "react";
import { api } from "../../../../convex/_generated/api";
import { TemplateFormEnum, TypeEvalEnum, estEvaluationSoumise } from "../../../../convex/schema";
import { StatutGlobalEnum, type FormsEvaluation } from "../lib/types";
import { CompletionModal } from "../components/completion-modal";
import { CandidateAutodiagTemplate } from "../templates/autodiag/autodiag-template";
import { CandidateEgogrammeTemplate } from "../templates/egogramme/egogramme-template";
import { CandidateCopsoq3Template } from "../templates/copsoq3/copsoq3-template";
import { ReorderForm } from "../templates/pami/pami-template";

export function Home() {
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const firstName = useCandidateAuthStore((state) => state.firstName);
  const token = useCandidateAuthStore((state) => state.token);
  const parcoursId = useCandidateAuthStore((state) => state.parcoursId);
  const { logout } = useCandidateLogout();

  const fullName = `${firstName} ${token}`.trim();
  const initials =
    `${firstName.charAt(0)}${token.charAt(0)}`.toUpperCase() || "CA";
  const evaluationId = useCandidateAuthStore((state) => state.evaluationId);
  const evaluationResponse = useQuery(
    api.evaluations.obtenirEvaluation,
    evaluationId && token && parcoursId ? { evaluationId, parcoursId, token } : "skip",
  );

  if (
    evaluationResponse === undefined ||
    evaluationResponse.evaluation === undefined
  ) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader />
      </div>
    );
  }

  // Verify evaluation is of type FORM
  if (
    evaluationResponse.evaluation &&
    evaluationResponse.evaluation.typeEval !== TypeEvalEnum.FORM
  ) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive">
            Type d'evaluation incorrect
          </h1>
          <p className="mt-2 text-muted-foreground">
            Cette evaluation n'est pas un formulaire.
          </p>
        </div>
      </div>
    );
  }

  const evaluation = evaluationResponse.evaluation as FormsEvaluation;

  const editable = !estEvaluationSoumise(evaluation.statut);

  const getTemplate = (template: TemplateFormEnum) => {
    switch (template) {
      case "autodiag":
        return CandidateAutodiagTemplate;
      case "egogramme":
        return CandidateEgogrammeTemplate;
      case "copsoq3":
        return CandidateCopsoq3Template;
      case "pami":
        return ReorderForm;
      default:
        return CandidateAutodiagTemplate;
    }
  };

  let FormTemplate = getTemplate(evaluation.donnees.template);

  return (
    <div className="relative flex h-screen w-screen flex-col bg-background">
      <Navbar
        title={"Formulaire"}
        userInfo={{
          displayName: fullName || "Candidat",
          subtitle: "Evaluation en cours",
          initials: initials || "CA",
        }}
        onLogout={logout}
      />
      <main className="px-4">
        <FormTemplate
          token={token}
          parcoursId={parcoursId}
          editable={editable}
          evaluation={evaluation}
          onComplete={() => setShowCompletionModal(true)}
        />
      </main>
      {showCompletionModal && (
        <CompletionModal onEnregistrer={() => setShowCompletionModal(false)} />
      )}
    </div>
  );
}
